export const promise = <T = unknown>(ms: number, data?: T) => {
	return new Promise((resolve) => {
		setTimeout(() => resolve(data), ms);
	});
};
